module.exports = __webpack_public_path__ + "static/media/minus-octagon.6b5731be.svg";